// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ti-or[data-v-d79d4814] {\n  position: relative;\n  height: 0;\n}\n.ti-or-inner[data-v-d79d4814] {\n  position: absolute;\n  top: -16px;\n  left: 50%;\n  background-color: #fff;\n  padding: 4px;\n  width: 50px;\n  margin-left: -25px;\n  text-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
